// extracted by mini-css-extract-plugin
export default {"root":"AssessmentDetails_root__4C17b","wrapper":"AssessmentDetails_wrapper__3Ymc0"};